/**
 * The shell's own header, gated on D8's `chromeHidden` flag
 * (`navigators/Application.tsx`'s desktop `<Header/>` block and its mobile-web
 * `headerShown` / `header` pair, three branches) — extracted so the one rule
 * driving every call site cannot drift, and so it is unit-testable without
 * rendering the 2000+ line shell.
 *
 * `wantsHeader` is whatever the branch's own PRE-EXISTING condition already
 * was (`!isMobileOrTab` on desktop, `isMobileOrTab` on mobile web) — this adds
 * exactly one more gate on top of it.
 */
export function shouldShowHeader(
  wantsHeader: boolean,
  chromeHidden: boolean,
): boolean {
  return wantsHeader && !chromeHidden;
}

export default shouldShowHeader;
